import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import settingsService from '../services/settingsService';

const useSettingsStore = create(
  persist(
    (set, get) => ({
      settings: null,
      loading: false,
      error: null,

      // Load settings (public or authenticated)
      loadSettings: async (isAuthenticated = false) => {
        set({ loading: true, error: null });
        try {
          const response = isAuthenticated
            ? await settingsService.getSettings()
            : await settingsService.getPublicSettings();
          set({ settings: response.data, loading: false });
          return response.data;
        } catch (error) {
          console.error('Error loading settings:', error);
          set({ error: error.message, loading: false });
          return null;
        }
      },

      // Update settings locally (after save)
      updateSettings: (newSettings) => {
        set({ settings: { ...get().settings, ...newSettings } });
      },

      // Clear settings (on logout)
      clearSettings: () => {
        set({ settings: null });
      },

      // Getters
      getWorkshopName: () => get().settings?.name || 'Sistema de Taller',
      getLogo: () => get().settings?.logo || null,
      getSlogan: () => get().settings?.slogan || '',
      getPhone: () => get().settings?.phone || '',
      getWhatsapp: () => get().settings?.whatsapp || '',
      getEmail: () => get().settings?.email || '',
      getAddress: () => get().settings?.address || {},
      getBusinessHours: () => get().settings?.businessHours || {},
      getSocialMedia: () => get().settings?.socialMedia || {},
      getShopType: () => get().settings?.shopType || 'vehicles',
    }),
    {
      name: 'workshop-settings',
      partialize: (state) => ({ settings: state.settings }),
    }
  )
);

export default useSettingsStore;
